'use client';

import { c as _c } from "react/compiler-runtime";
import { useQueryState } from 'nuqs';
import { memo, useMemo } from 'react';
import type { PortfolioActivityMode } from '@/lib/analytics/client/events';
import ActivityModeButtons from './ActivityModeButtons';
import DashboardBorrowActivity from './components/DashboardBorrowActivity';
import DashboardEarnActivity from './components/DashboardEarnActivity';
import DashboardLiquidationActivity from './components/DashboardLiquidationActivity';
export type DashboardActivityMode = PortfolioActivityMode;
const DashboardActivity = () => {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      defaultValue: "earn",
      parse: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [mode, setMode] = useQueryState("activityMode", t0);
  let t1;
  bb0: {
    let t2;
    if ($[1] !== mode || $[2] !== setMode) {
      t2 = <ActivityModeButtons mode={mode} onModeChange={setMode} />;
      $[1] = mode;
      $[2] = setMode;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    const modeButtons = t2;
    switch (mode) {
      case "earn":
        {
          let t3;
          if ($[4] !== modeButtons) {
            t3 = <DashboardEarnActivity>{modeButtons}</DashboardEarnActivity>;
            $[4] = modeButtons;
            $[5] = t3;
          } else {
            t3 = $[5];
          }
          t1 = t3;
          break bb0;
        }
      case "borrow":
        {
          let t3;
          if ($[6] !== modeButtons) {
            t3 = <DashboardBorrowActivity>{modeButtons}</DashboardBorrowActivity>;
            $[6] = modeButtons;
            $[7] = t3;
          } else {
            t3 = $[7];
          }
          t1 = t3;
          break bb0;
        }
      case "liquidation":
        {
          let t3;
          if ($[8] !== modeButtons) {
            t3 = <DashboardLiquidationActivity>{modeButtons}</DashboardLiquidationActivity>;
            $[8] = modeButtons;
            $[9] = t3;
          } else {
            t3 = $[9];
          }
          t1 = t3;
          break bb0;
        }
      default:
        {
          t1 = null;
        }
    }
  }
  const renderActivityComponent = t1;
  let t2;
  if ($[10] !== renderActivityComponent) {
    t2 = <div className="gap-sm flex w-[100%] flex-col"><div>{renderActivityComponent}</div></div>;
    $[10] = renderActivityComponent;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};
export default memo(DashboardActivity);
function _temp(value) {
  return value as DashboardActivityMode;
}